import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Footer = () => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-900 to-primary-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDMwaC0yVjBoMnYzMHptLTIgMEgydjJoMzJ2LTJ6bTAgMnYyOGgydi0yOGgtMnptMiAwaDI4di0ySDM2djJ6Ii8+PC9nPjwvZz48L3N2Zz4=')] opacity-10"></div>
      
      <motion.div 
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        className="container mx-auto px-6 py-12 relative"
      >
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <motion.div variants={item} className="space-y-4">
            <h3 className="text-2xl font-bold font-display bg-gradient-to-r from-primary-400 to-secondary-400 text-transparent bg-clip-text">
              Civic Guru
            </h3>
            <p className="text-gray-400">
              Your AI-powered Legal Assistant on WhatsApp
            </p>
          </motion.div>
          
          <motion.div variants={item} className="space-y-4">
            <h4 className="text-lg font-semibold text-primary-400">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors hover:translate-x-1 inline-block">
                  About
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-white transition-colors hover:translate-x-1 inline-block">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-white transition-colors hover:translate-x-1 inline-block">
                  Blog
                </Link>
              </li>
            </ul>
          </motion.div>
          
          <motion.div variants={item} className="space-y-4">
            <h4 className="text-lg font-semibold text-secondary-400">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors hover:translate-x-1 inline-block">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors hover:translate-x-1 inline-block">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </motion.div>
          
          <motion.div variants={item} className="space-y-4">
            <h4 className="text-lg font-semibold text-accent-400">Contact</h4>
            <ul className="space-y-2">
              <li className="text-gray-400 flex items-center space-x-2">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                <span>mike@civicguru.co.zw</span>
              </li>
              <li className="text-gray-400 flex items-center space-x-2">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                <span>+263 771-709-668</span>
              </li>
            </ul>
            <div className="flex space-x-4 mt-4">
              <motion.a 
                href="https://www.tiktok.com/@designmate7" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                TikTok
              </motion.a>
              <motion.a 
                href="https://www.instagram.com/designmateai/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                Instagram
              </motion.a>
            </div>
          </motion.div>
        </div>
        
        <motion.div 
          variants={item}
          className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400"
        >
          <p className="text-sm">
            ©Civic Guru by Codebytes Consulting (2024) • All rights reserved
          </p>
        </motion.div>
      </motion.div>
    </footer>
  );
};

export default Footer; 